<template>
  <div class="article_item" @click="toArticle()">
    <div class="item_pic" v-if="article_item.pic">
      <img :src="article_item.pic" alt />
    </div>
    <div class="item_main">
      <h5>{{ article_item.name }}</h5>
      <span>{{ article_item.span }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: ["article_item"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    async toArticle() {
      this.$router.push({
        path: "/Article",
        query: {
          id: this.article_item.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.article_item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 0px 0;
  background-color: #fff;
  .item_pic {
    width: 42%;
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .item_main {
    width: 58%;
    overflow: hidden;
    margin-left: 10px;
    h5 {
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 0 10px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    span {
      color: #666;
      font-size: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
